import {UMakeTypes} from "../../../cars_data/cars_data";
import {capitalizeFirstLetter} from "./capitalize_first_letter";

type UMakeKey = keyof typeof UMakeTypes;

/**
 * Maps URL slug (`bmw`, `mercedesbenz`) or label (`BMW`, `Mercedes-Benz`) to display name.
 */
export const formatMakeDisplayName = (make?: string | null) => {
    if (!make) {
        return "";
    }
    const raw = String(make).trim();
    if (!raw) {
        return "";
    }
    const slugKey = raw.toLowerCase().replace(/[-\s]/g, "") as UMakeKey;
    if (Object.prototype.hasOwnProperty.call(UMakeTypes, slugKey)) {
        return UMakeTypes[slugKey];
    }
    const byLabel = Object.values(UMakeTypes).find((label) => label.toLocaleLowerCase("pl") === raw.toLocaleLowerCase("pl"));
    if (byLabel) {
        return byLabel;
    }
    return capitalizeFirstLetter(raw);
};
